import styled from 'styled-components'

export const ContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1296px;
  width: 100%;
  margin-top: 140px;

  h1 {
    width: fit-content;
  }

  h2 {
    width: fit-content;
  }

  .mobileEx {
    display: none;

    @media (max-width: 768px) {
      display: block;
      justify-self: center;

      img {
        max-width: 615px;
        width: 100%;
        height: 243px;
      }
    }
  }

  .desktopEx {
    display: block;

    @media (max-width: 768px) {
      display: none;
    }
  }

  p {
    width: fit-content;
  }

  span {
    width: fit-content;
    display: flex;
    gap: 4px;
    font-size: 16px;
    line-height: 24px;
    color: #7077ec;
    font-family: 'Bai Jamjuree', serif;
    font-weight: 500;
  }
  p {
    width: fit-content;
    max-width: 1296px;
    color: #f3f3f3;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: 'Assistant', serif;
  }

  img {
    width: 438px;
    height: 341px;
  }
`
export const ContainerDesc = styled.div`
  margin-top: 64px;

  h2 {
    max-width: 1296px;
    width: fit-content;
  }

  p {
    width: fit-content;
    max-width: 1296px;

    @media (max-width: 768px) {
      padding-right: 0;
    }
  }

  span {
    a {
      color: #c6f688;
      font-weight: 400;
    }
  }
  .problemaDesc {
    margin-top: 64px;
  }

  .analiseCards {
    margin-top: 40px;
    font-family: 'Bai Jamjuree', serif;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-bottom: 64px;
  }

  .analysisCard {
    background: #202020;
    border: 1px solid #a8d65f;
    border-radius: 24px;
    font-family: 'Bai Jamjuree', serif;
    padding: 28px;
    display: flex;
    flex-direction: column;
    transition: 0.25s ease;

    @media (max-width: 376px) {
      width: 90%;
    }

    &:hover {
      transform: translateY(-4px);
      border-color: #b7e96c;
    }

    h3 {
      color: #b9e769;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 24px;
    }

    p {
      color: #d5d5d5;
      line-height: 1.8;
      font-size: 14px;
      margin-bottom: 32px;
      font-family: 'Bai Jamjuree', serif;
    }

    img {
      width: 333px;
      height: 308px;
      object-fit: contain;
      margin-top: auto;
      align-self: center;

      @media (max-width: 376px) {
        width: 250px;
      }
    }
  }

  @media (max-width: 900px) {
    .analiseCards {
      grid-template-columns: 1fr;
    }
  }

  .JornadaUsuario {
    @media (max-width: 426px) {
      display: none;
    }
    img {
      max-width: 1296px;
      width: 100%;
      height: auto;

      @media (max-width: 768px) {
        width: 600px;
        display: flex;
        justify-self: center;
      }
    }
  }
`
export const ContainerStyledImgs = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  max-width: 1296px;

  @media (max-width: 1024px) {
    display: block;
    justify-self: center;
  }

  .desktopSocio {
    max-width: 934px;
    width: 100%;
    @media (max-width: 1024px) {
      display: none;
    }
  }
  .mobileSocio {
    display: none;
    max-width: 400px;
    width: fit-content;

    @media (max-width: 1024px) {
      margin-top: 24px;
      display: block;
    }
    @media (max-width: 425px) {
      width: 280px;
    }
  }
  img {
    max-width: 935px;
    @media (max-width: 1024px) {
      margin-top: 24px;
      display: block;
      justify-self: center;
    }
  }
`
export const IframeStyled = styled.div`
  iframe {
    border: 1px solid rgba(0, 0, 0, 0.08);
    min-height: 725px;
    max-width: 1296px;
    width: 100%;
  }

  @media (max-width: 425px) {
    max-width: 280px;
    width: 100%;
    margin: 0 auto;

    iframe {
      max-width: 280px;
      margin: 0;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`
